export function openWhatsApp(message: string, phone = "2348138838732") {
  const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
  // Open in a new tab/window
  if (typeof window !== "undefined") {
    window.open(url, "_blank");
  }
}

export default openWhatsApp;
